import { getElementType } from '../../../common/elements/utils/elementPropertyUtils';
import { ElementType } from '../../../common/elements/elementTypes';
import { getIsLinkMediaVisible } from '../link/linkUtils';
import { getIsFileMediaVisible } from '../file/utils/fileElementUtils';
import { ImMNElement, MNFileContent } from '../../../common/elements/elementModelTypes';

/**
 * Determines if the media component for a given element is currently being displayed.
 * This includes displaying either the media itself or a placeholder.
 */
export const isMediaComponentVisible = (props: { element: ImMNElement; attachment?: MNFileContent }) => {
    const { element, attachment } = props;

    switch (getElementType(element)) {
        case ElementType.LINK_TYPE:
            return getIsLinkMediaVisible(element);
        case ElementType.FILE_TYPE:
            return getIsFileMediaVisible({ element, attachment });
        default:
            // Other element types either don't have media to show (e.g. Note) or will show a placeholder if no image (e.g. Image)
            return true;
    }
};
